/**
 * @file The right sidebar of the application.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { RouterOutlet } from '@angular/router';
import { EventEmitter, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AbstractBase } from '../../core/helpers/abstract-base';
/**
 * The container that holds the filter editor and detail views on the right side of the application.
 */
var SidebarRightComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SidebarRightComponent, _super);
    /**
     * Creates an instance of SidebarRightComponent.
     */
    function SidebarRightComponent() {
        var _this = _super.call(this) || this;
        /** Event to notify when the sidebar is closing for a reason. */
        _this.closed = new EventEmitter();
        // Keep track of the activate and deactive events
        _this.activateDeactiveStream = new BehaviorSubject(false);
        return _this;
    }
    SidebarRightComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriptionPool.add(this.activateDeactiveStream.pipe(debounceTime(100), distinctUntilChanged()).subscribe(function (open) {
            if (open === false) {
                _this.isClosing();
            }
        }));
    };
    /**
     * Checks whether the this right side bar should be open.
     * @returns True when this right side bar should be shown.
     */
    SidebarRightComponent.prototype.isOpen = function () {
        if (!this.outlet) {
            return false;
        }
        return this.outlet.isActivated;
    };
    SidebarRightComponent.prototype.onDeactivate = function (event) {
        this.activateDeactiveStream.next(false);
    };
    SidebarRightComponent.prototype.onActivate = function (event) {
        this.activateDeactiveStream.next(true);
    };
    SidebarRightComponent.prototype.isClosing = function () {
        this.closed.emit('sidebar');
    };
    return SidebarRightComponent;
}(AbstractBase));
export { SidebarRightComponent };
